import styled from 'styled-components';

export const SpinnerContainer = styled.div`
    position: absolute !important;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    background-color: #ffffff;

    svg {
        width: 3rem;
        height: 3rem;
    }
`;
